import { useSegmentDrawConfigV1ControllerGetByProject } from 'generated/apiComponents';
import { useSession } from 'technical/auth/client';

export const useGetSegmentDrawConfigData = (options = {}) => {
  const { data: session } = useSession();

  const { data, error, isLoading, refetch } =
    useSegmentDrawConfigV1ControllerGetByProject(
      {
        queryParams: {
          projectId: session?.user.projectId ?? '',
        },
      },
      {
        enabled: !!session?.user.projectId,
        ...options,
      },
    );

  return {
    data,
    loading: isLoading,
    error,
    refetch,
  };
};
